import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Scratch Made", "Southern Hospitality", "Louisiana Soul", "Cast Iron Cooking",
  "Sunday Suppers", "East Texas Home", "Made From The Heart",
];

export const RibbonMarquee = ({ dark = true }) => (
  <div
    className={`py-6 border-y ${dark ? "bg-hb-black border-hb-line" : "bg-hb-creamsurface border-hb-linelight"}`}
    data-testid="ribbon-marquee"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-serif italic text-3xl md:text-5xl px-8 ${
              dark ? "text-hb-cream" : "text-hb-ink"
            }`}
          >
            {w}
          </span>
          <span className="text-hb-brass text-2xl md:text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
